import { render, staticRenderFns } from "./PH26V.vue?vue&type=template&id=f31446d8&scoped=true"
import script from "./PH26V.vue?vue&type=script&lang=js"
export * from "./PH26V.vue?vue&type=script&lang=js"
import style0 from "./PH26V.vue?vue&type=style&index=0&id=f31446d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31446d8",
  null
  
)

export default component.exports